import ContentRouter from './ContentRouter';
export default ContentRouter;



// WEBPACK FOOTER //
// ./src/components/App/ContentRouter/index.js